module.exports = __webpack_public_path__ + "static/img/scyhydd-BLOVE5Yr.78bd274.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/scyhydd-BLOVE5Yr.png
// module id = EFn4
// module chunks = 16